export const OPEN_MENU = [
  {
    id: "clone",
    name: "Clone Request",
  },
];

export const CLOSED_MENU = [
  {
    id: "clone",
    name: "Clone Request",
  },
];

export const TASK_MENU = [
  {
    id: "view",
    name: "View",
  },
  {
    id: "addComment",
    name: "Add Comment",
  },
  {
    id: "delete",
    name: "Delete",
  },
];

export const CONDITIONAL_TASK_MENU = [
  {
    id: "view",
    name: "View",
  },
  {
    id: "addComment",
    name: "Add Comment",
  },
];

export const getHeadersFromStage = (flag: boolean) =>
  flag
    ? [
      "Request For",
      "Screened by TT",
      "Shortlist",
      "Client endorsement",
      "Client interview",
      "Offer",
      "Candidate started",
      "",
    ]
    : [
      "Request For",
      "Reason of cancellation",
      "Client name",
      "Cancelled on",
      "Cancelled by",
      "",
    ];

export const DISQUALIFICATION_REASON = [
  {
    name: "Poor verbal communication skills",
    value: "Poor verbal communication skills",
  },
  {
    name: "Unable to respond to questions clearly and concisely",
    value: "Unable to respond to questions clearly and concisely",
  },
  {
    name: "Less enthusiasm for the role or industry",
    value: "Less enthusiasm for the role or industry",
  },
  {
    name: "Work style don't align with the company's culture",
    value: "Work style don't align with the company's culture",
  },
  {
    name: "Salary expectations are too high",
    value: "Salary expectations are too high",
  },
  {
    name: "Lacks in technical skills",
    value: "Lacks in technical skills",
  },
  {
    name: "Impersonating someone else",
    value: "Impersonating someone else",
  },
  {
    name: "Junior profile",
    value: "Junior profile",
  },
  {
    name: "CV not aligned with the job description",
    value: "CV not aligned with the job description",
  },
  {
    name: "Office location is too far",
    value: "Office location is too far",
  },
  {
    name: "Voluntary withdrawal",
    value: "Voluntary withdrawal",
  },
  {
    name: "Other",
    value: "Other",
  }
];
